import {useQuery} from 'react-query';

import getPromotedAdvertisement from '.';
interface IUseGetPromotedAdvertisementPyload {
  guid?: string;
}
const useGetPromotedAdvertisement = ({
  guid,
}: IUseGetPromotedAdvertisementPyload) => {
  const {data, isLoading} = useQuery(
    ['promoted-advertisemen', guid],
    () => getPromotedAdvertisement(guid),
    {enabled: guid ? true : false},
  );
  return {data, isLoading};
};

export default useGetPromotedAdvertisement;
